import { Button } from "@/components/ui/button";
import { config } from "@/config";
import { useApi } from "@/hooks/use-api";
import { useFlow } from "@frigade/react";
import { BadgeCheck } from "lucide-react";
import { useNavigate } from "react-router";
import { OnboardingSteps } from "./OnboardingGuide";
import { useOnboardingVisibility } from "./useOnboardingVisibility";

const CompleteOnboarding = () => {
  const { flow } = useFlow(config.frigade.flows.gettingStarted);
  const currentStep = flow?.getCurrentStep();
  const navigate = useNavigate();
  const { completeOnboarding } = useApi();
  const shouldRender = useOnboardingVisibility();

  if (!shouldRender || (currentStep?.id as OnboardingSteps) !== "complete_onboarding") {
    return null;
  }

  const handleCompleteOnboarding = async () => {
    const step = flow?.getCurrentStep();
    await step?.complete();
    await completeOnboarding();

    navigate("/inbox/done");
  };

  return (
    <div
      className={`w-[400px] border-1 border-[#E8EAED] rounded-lg bg-white z-50 p-4 mb-4`}
    >
      <div className="flex flex-row items-center space-x-2 pb-2">
        <BadgeCheck />
        <h3>Onboarding Completed</h3>
      </div>

      <p className="text-sm mt-2 mb-4">
        You’ve successfully completed the onboarding. You can now access your
        report by copying the access details and opening the URL in your
        browser.
      </p>

      <Button
        className="bg-[#FF5430] text-white hover:bg-[#E0401F]"
        onClick={handleCompleteOnboarding}
      >
        Finish Onboarding
      </Button>
    </div>
  );
};

export default CompleteOnboarding;
